import {
  OrganizationalUnitDTO,
  MasterDataDTO,
  DivisionDTO,
  DocumentClassDTO,
  TaskDTO,
  IObjectDTO,
  FavouriteProjectDTO,
  PersonDTO,
  BaseObjectDTO,
  AssignedServiceProjectDTO,
  Link,
  ProjectIndicatorDTO,
  CofinancingDTO
} from './plyca-dtos';
import { ServiceLocator } from '../ServiceLocator';
import { HelpService } from '../components/common/help/help.service';
import { FieldConfig } from './contract-notice-dto';
import { AwardDTO, BudgetAccountLineDTO, ContractDTO, ObjectContextDTO, ProjectEntityDTO } from './plyca-dtos-v2';
import { NumberSymbol } from '@angular/common';
import { AnnuityAmountDTO } from './sarga-dtos';

export class BaseDivisionDTO implements BaseObjectDTO<string> {
  links: Link[];
  identifier: string;
  task: TaskDTO;

  parent: DivisionDTO;
  children: DivisionDTO[];

  creationDate: Date;
  name: string;

  documentClass: DocumentClassDTO;
  type: MasterDataDTO;
  phase: MasterDataDTO;

}

// BaseProjectEntityDTO
export class BaseProjectEntityDTO extends BaseDivisionDTO {
  contractFolderId: string;

  startDate: Date;
  organizationalUnit: OrganizationalUnitDTO;
  opcProcedure: boolean;
  title: string;
  favourite: FavouriteProjectDTO;
  // DivisionDTO
  identifier: string;

  procedure: MasterDataDTO;
  usuid: string;

}

export class InfrastructurePlanDTO extends BaseProjectEntityDTO implements IObjectDTO<string> {
  task: TaskDTO;
  startYear: number;
  endYear: number;
  agent: string;
  approvalType: MasterDataDTO;
  resource: boolean;
  discontinued: boolean;
  remarks: string;
  initialBudget: number;
  finalBudget: number;
  communityFinancing: boolean;
  affectedFinancing: boolean;
  plannedActions: PlannedActionDTO[];
}

export class PlannedActionDTO {
  year: number;
  actions: number;
  amount: number;
}
export class SpendingProjectDTO extends BaseProjectEntityDTO implements IObjectDTO<string> {
  identifier: string;
  context?: ObjectContextDTO;
  task: TaskDTO;
  entity: MasterDataDTO;
  road: MasterDataDTO;
  fileCreationType: MasterDataDTO;
  activeCode: String;
  workType: MasterDataDTO;
  approvalType: MasterDataDTO;
  inversionType: MasterDataDTO;
  axis: MasterDataDTO;
  measure: MasterDataDTO;
  observations: String;
  center: CenterDTO;
  participateObservations: String;
  totalAmount: Number;
  investmentType: MasterDataDTO;
  infrastructurePlan: InfrastructurePlanDTO;
  budgetAccountLines: BudgetAccountLineDTO[];
  cofinancingLine: CofinancingLineDTO[];
  totalBudgetAccountLines: number;
  totalCofinancingLines: number;
  assignedServices: AssignedServiceProjectDIPBADDTO[];
  projectIndicators: ProjectIndicatorsDTO[];
}

export interface WorkSpendingProjectDTO extends BaseObjectDTO<string> {
  identifier: string;
  spendingProject: SpendingProjectDTO;
  context?: ObjectContextDTO;
}

export interface WorkCertificationPaymentDTO extends BaseObjectDTO<string> {
  identifier: string;
  certificationPayment: CertificationPaymentDTO;
  context?: ObjectContextDTO;
}

export class CertificationPaymentDTO implements IObjectDTO<string> {
  identifier: string;
  task: TaskDTO;
  division: DivisionDTO;

  participants: ParticipantPaymentDTO[];
  expenseType: string;
  listMonth: any;
  annuity: string;

  initialContractAmount: number;
  modificationAmount: number;
  revisionAmount: number;
  settlementAmount: number;
  amount: number;
  spendingProject: SpendingProjectDTO;
  award: AwardDTO;
  amountPrev: number;

  modificationBudget: number;
  budgetReview: number;
  pendingPayment: number;

  //Anualidades del contrato, las anualidades registradas para el contrato en la tabla ANUALIDADES_CONTRATO
  budgetAccountLinesContract: AnnuityAmountDTO[];
  //Participes tanto del contrato como de las incidencias
  cofinancedLinesContract: CofinancingLineDTO[];
  alreadySpentAnnuities: AnnuityAmountDTO[];
  participantsContract: ParticipantPaymentDTO[];
}

export class ParticipantPaymentDTO {
  participantId: number;
  cofinanciedId: number;
  year: number;
  amount: number;
  percentagePart: number;


}

export class CenterDTO {
  center: MasterDataDTO;
}

export interface AssignedServiceProjectDIPBADDTO
  extends BaseObjectDTO<string>,
  IObjectDTO<string> {
  organizationalUnit: MasterDataDTO;
  tipo: MasterDataDTO;
}

export class ProjectIndicatorsDTO {
  indicatorId: string;
  number: number;
  orden: number;
  projectIndicator: ProjectIndicatorDIPBADDTO;
}

export class ProjectIndicatorDIPBADDTO {
  indicatorId: MasterDataDTO;
  indicatorType: string;
}

export interface CofinancingLineDTO
  extends BaseObjectDTO<string>,
  IObjectDTO<string> {
  budgetYear: number;
  entity: string;
  entityDescription: string;
  approvalDate: Date;
  budgetAmount: number;
  // Campo auxiliar para rellenar luego con el entity y entityDescription
  participant: MasterDataDTO;
}

